// eslint-disable-next-line no-unused-vars
function calculatePriceWithDiscount(price, quantity) {
	const totalPrice = price * quantity;
	const tenPercent = totalPrice * 0.1;
	const twentyPercent = totalPrice * 0.2;

	let val;
	if (quantity >= 3) {
		val = totalPrice - twentyPercent;
	} else {
		val = totalPrice - tenPercent;
	}
	return val;
}
